import { AxiosResponse } from "axios";
import API from "../api";

import { IUploadCentreCreateServiceList, Service as ServiceModel } from "../models/service";

const endpoint = "services";

const Service = {
  async getTypes(options?: any): Promise<AxiosResponse<string[]>> {
    return API.get(`/${endpoint}/types`, { params: options });
  },
  async count(options?: any): Promise<AxiosResponse<number>> {
    return API.get(`/${endpoint}/count`, { params: options });
  },
  async getAll(options?: any): Promise<AxiosResponse<ServiceModel[]>> {
    return API.get(`/${endpoint}`, { params: options });
  },
  async create(serviceBooking: ServiceModel): Promise<AxiosResponse<ServiceModel>> {
    return API.post(`/${endpoint}`, serviceBooking);
  },
  async update(id: number, serviceBooking: ServiceModel): Promise<AxiosResponse<boolean>> {
    return API.put(`/${endpoint}/${id}`, serviceBooking);
  },
  async postCSV(data: IUploadCentreCreateServiceList[]): Promise<AxiosResponse<ServiceModel[]>>{
    return await API.post(`/${endpoint}/list`, data);
  },
};

export default Service;
